import React, { useEffect, useState } from 'react';
import PotreeViewer from './PotreeViewer';
import Toolbar from './Toolbar'; // We will create this next
import NavCube from './NavigationCube';
import './App.css';
import CameraControls from './CameraControls';
import OptionsPanel from './OptionsPanel';
import ScenePanel from './ScenePanel';
import { TooltipProvider } from './Tooltip';
import Loader from './Loader';

function App() {
  const [viewer, setViewer] = useState(null);
  const [savePath, setSavePath] = useState(null);
  const [permission, setPermission] = useState('read'); // Default to 'read-only'
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const perm = urlParams.get('permission');

    if (perm === 'write') {
      setPermission('write');
      console.log("Write permissions granted.");
    } else {
      console.log("Read-only mode enabled.");
    }
  }, []); 

  const handleViewerLoaded = (viewerInstance, path) => {
    setViewer(viewerInstance);
    setSavePath(path);
  };

  function Logo() {
    return (
      <div className="app-logo">
        <img src="signak-logo.png" alt="Signak by ALPICAPTURE" />
      </div>
    );
  }

  return (
    <TooltipProvider>
      <div className="App">
        {isLoading && <Loader />}

        <PotreeViewer onViewerLoaded={handleViewerLoaded} setIsLoading={setIsLoading}/>
        <Logo />
        {/* Only render the Toolbar once the viewer is ready */}
        {viewer &&
          <>
            <NavCube viewer={viewer} />
            <Toolbar viewer={viewer} />
            <CameraControls viewer={viewer} />
            <OptionsPanel viewer={viewer} savePath={savePath} permission={permission}/>
            <ScenePanel viewer={viewer} />
          </>
        }
      </div>
    </TooltipProvider>
  );
}

export default App;